import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { DesktopOverflowText } from '@/components/common/admin/desktop/DesktopOverflowText';

export const TaskActions = ({
  taskId,
  isArchived,
  onDuplicate,
  onArchive,
}: {
  taskId: number;
  isArchived: boolean;
  onDuplicate?: (taskId: number) => void;
  onArchive?: (taskId: number) => void;
}) => {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
      {onDuplicate && (
        <TouchableOpacity
          style={{ padding: 4, position: 'relative' }}
          onPress={(e: any) => { try { e?.stopPropagation?.(); } catch {} onDuplicate(taskId); }}
          accessibilityLabel="Duplicate Task"
          testID={`task-row-duplicate-${taskId}`}
        >
          <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10 }}>
            <DesktopOverflowText title={'Duplicate Task'} text={''} tooltipText={''} numberOfLines={1} align={'center'} />
          </View>
          <View pointerEvents={'none'}>
            <SVG_COMPONENTS.COPY width={16} height={16} />
          </View>
        </TouchableOpacity>
      )}
      {onArchive && (
        <TouchableOpacity
          style={{ padding: 4, position: 'relative' }}
          onPress={(e: any) => { try { e?.stopPropagation?.(); } catch {} onArchive(taskId); }}
          accessibilityLabel={isArchived ? 'Unarchive Task' : 'Archive Task'}
          testID={`task-row-archive-${taskId}`}
        >
          <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10 }}>
            <DesktopOverflowText title={isArchived ? 'Restore Task' : 'Archive Task'} text={''} tooltipText={''} numberOfLines={1} align={'center'} />
          </View>
          <View style={{ transform: [{ rotate: isArchived ? '180deg' : '0deg' }] }} pointerEvents={'none'}>
            <SVG_COMPONENTS.ARCHIVE width={16} height={16} />
          </View>
        </TouchableOpacity>
      )}
    </View>
  );
};


